import { Alert, AlertTitle, Link } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'

import { ControllerRouteInformation } from '@/features/controller/constants'
import type { ResourceJsonErrorCode } from '@/features/resource/configuration/endpoints/resourceJsonConfiguration'
import { resourceJsonErrorMessage } from '@/features/resource/configuration/utils/resourceJsonErrorCodes'

type ResourceJsonErrorAlertProps = {
  code: ResourceJsonErrorCode
  controllerId: string | null
}

export function ResourceJsonErrorAlert({ code, controllerId }: Readonly<ResourceJsonErrorAlertProps>) {
  const { t } = useTranslation()

  const message = resourceJsonErrorMessage(code, t)

  const fallback = (() => {
    if (code === 'MULTIPLE_CONTROLLERS') {
      return (
        <Link component={RouterLink} to={ControllerRouteInformation.INDEX.navigationPath()}>
          {t('resources.configuration.error.open_controllers_list')}
        </Link>
      )
    }
    if (controllerId) {
      return (
        <Link
          component={RouterLink}
          to={ControllerRouteInformation.CONTROLLER_CONFIG_RESOURCE_JSON.navigationPath(controllerId)}
        >
          {t('resources.configuration.error.open_controller_config')}
        </Link>
      )
    }
    return null
  })()

  return (
    <Alert severity="error" sx={{ mb: 2 }}>
      <AlertTitle>{t('resources.configuration.error.title')}</AlertTitle>
      {message}
      {fallback && <div>{fallback}</div>}
    </Alert>
  )
}
